/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsercenteCancellazioneRiepilogoDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EsercenteAccountServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cancella il proprio account esercente (anonimizzazione irreversibile).
     * Audience: ESERCENTE autenticato. Anonimizza il titolare e, a cascata, i suoi cassieri (esclusi quelli che lavorano anche per un\&#39;altra impresa, che vengono solo scollegati); azzera PEC/IBAN del profilo e i contatti dei punti vendita, disabilita gli account in Keycloak e revoca le sessioni. Le domande presentate restano nel loro stato. La partita IVA resta sul profilo ma puo\&#39; essere registrata di nuovo. Operazione irreversibile. Dopo una risposta 200 il client deve smontare la sessione locale senza chiamare il logout.
     * @endpoint delete /api/v1/esercente/account
*/
    eliminaAccountEsercente(extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Cosa comporta la cancellazione dell\&#39;account esercente.
     * Audience: ESERCENTE autenticato. Restituisce quante rendicontazioni sono ancora da inviare e quanti cassieri verrebbero cancellati insieme all\&#39;account. Sola lettura.
     * @endpoint get /api/v1/esercente/account/riepilogo-cancellazione
*/
    getRiepilogoCancellazioneAccountEsercente(extraHttpRequestParams?: any): Observable<EsercenteCancellazioneRiepilogoDTO>;

}
